// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"e5767d07","977":"8f581a1b"}[chunkId] + ".chunk.js";
};